import type { TrackData } from '../types';

export const TrackApi = Symbol('TrackApi');

export interface TrackApi {
    track(dataTrack: TrackData): Promise<boolean>;
}
